export default __webpack_public_path__ + "static/nualas-fc6a2ae2679ab05a656ecba308cf1a5a.svg";